import React from 'react'
import DeviceSettingsTimerMethods, { IDeviceSettingsTimerProps } from './deviceSettings__timer.local.methods'
import EditText from 'blocks.simple/editText/editText'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import RangeVolume from 'blocks.simple/range/_volume/range_volume'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './styles'
import item from 'blocks.simple/item/item.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { Typography } from '../../../atoms/Typography'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import { Button } from 'molecules/Button'

const repeatOptions = [
    { name: translate('never'), setup: 'off' },
    { name: translate('once'), setup: 'once' },
    { name: translate('daily'), setup: 'daily' },
    { name: translate('weekly'), setup: 'weekly' },
]

const DeviceSettingsTimer = (p_: IDeviceSettingsTimerProps) => {
    const dispatch = useDispatch()
    const {
        state,
        setState,
        onChangeTime,
        onChangeRepeat,
        onSelectDays,
        onChangeVolume,
        onChangeRebootType,
        onChangeSleepMode,
    } = DeviceSettingsTimerMethods(p_)

    const s_ = state
    const isSingle = s_.timers.on && s_.timers.on.length === 1
    const timer = s_.timers.on[s_.activeTabIndex]
    const offTimer = s_.timers.off[s_.activeTabIndex]
    const index = s_.activeTabIndex
    const isDisplayTimer = p_.type === 'display'
    const showVolumeOnStart = p_.type === 'onOff' && p_.platform !== 'webos'
    const showAndroidWarning = p_.platform === 'android' && !isDisplayTimer
    const showVolumeSection = showVolumeOnStart || showAndroidWarning

    return (
        <div style={{ width: '100%' }}>
            {!isSingle && (
                <div className={styles.tabs}>
                    {s_.timers.on.map((_: any, id: number) => (
                        <Button
                            className={styles.tab}
                            onClick={() => {
                                setState({
                                    ...s_,
                                    activeTabIndex: id,
                                })
                            }}
                            mod={s_.activeTabIndex === id ? 'fillBrand' : ''}
                        >
                            {`${id + 1} ${translate('deviceTimer')}`}
                        </Button>
                    ))}
                </div>
            )}
            <div key={`device_settings_timer_${index}`} className={styles.timerContainer}>
                <div className={cn(isSingle ? styles.singleTimer : styles.timer)}>
                    {p_.type !== 'reboot_timers' && (
                        <div className={cn(grid.mb_mini, grid.row)}>
                            <div className={cn(styles.onIcon, grid.mr_mini)}></div>
                            {translate(isDisplayTimer ? 'onDisplayTimer' : 'onTimer')}
                        </div>
                    )}
                    <div className={cn(styles.timers)}>
                        <div className={cn(grid.mt_md, grid.fullWidth)}>
                            <Dropdown
                                mod={'default'}
                                options={repeatOptions}
                                valueField={'setup'}
                                label={translate('repeat')}
                                value={timer.setup}
                                onChange={(selected) => onChangeRepeat(selected, 'on', index)}
                            />
                        </div>
                        {timer.setup === 'once' && (
                            <div className={cn(grid.mt_md, grid.fullWidth)}>
                                <EditText
                                    mod={'withBorder'}
                                    label={translate('date')}
                                    type="date"
                                    value={timer.date && moment(timer.date).format('DD.MM.YYYY')}
                                    onChange={(value: string) => {
                                        const s_ = { ...state }
                                        const date = moment(value).set({
                                            hour: 0,
                                            minute: 0,
                                            second: 0,
                                            millisecond: 0,
                                        })
                                        const dateNow = moment().set({
                                            hour: 0,
                                            minute: 0,
                                            second: 0,
                                            millisecond: 0,
                                        })

                                        if (date < dateNow) {
                                            dispatch(emitError('timerCantBeLessDateNow'))

                                            return
                                        }
                                        if (offTimer && offTimer.date) {
                                            const offDate = moment(offTimer.date).set({
                                                hour: 0,
                                                minute: 0,
                                                second: 0,
                                                millisecond: 0,
                                            })

                                            // if (date > offDate) {
                                            //     dispatch(emitError('timerCantBeMoreOffDate'))
                                            //
                                            //     return
                                            // }
                                        }

                                        s_.timers['on'][index].date = moment(value).toISOString(true)

                                        setState(s_)
                                    }}
                                    //minDate={moment().toDate()}
                                    //maxDate={offTimer && offTimer.date ? moment(offTimer.date).toDate() : null}
                                />
                            </div>
                        )}
                        {timer.setup !== 'off' && (
                            <div className={cn(grid.mt_md, grid.fullWidth)}>
                                <EditText
                                    mod={'withBorder'}
                                    label={translate('time')}
                                    type="text"
                                    mask="99:99:99"
                                    value={timer.time}
                                    onChange={(value: string) => {
                                        const s_ = { ...state }
                                        s_.timers['on'][index].time = value

                                        setState(s_)
                                    }}
                                    onBlur={(value: string) => onChangeTime(value, 'on', index)}
                                />
                            </div>
                        )}
                        {timer.setup === 'weekly' && (
                            <div
                                className={cn(
                                    { [item.hidden]: timer.setup !== 'weekly' },
                                    grid.row,
                                    grid.mt_mini,
                                    grid.center,
                                    grid.fullWidth
                                )}
                            >
                                {s_.days.map((day, i) => {
                                    const dayIndex = i + 1

                                    return (
                                        <div key={`day__checkbox_${dayIndex}`}>
                                            <Checkbox
                                                checked={
                                                    timer.repeatDays ? timer.repeatDays.indexOf(dayIndex) !== -1 : false
                                                }
                                                onClick={(selected: any) =>
                                                    onSelectDays(selected, dayIndex, 'on', index)
                                                }
                                            />
                                            <div className={cn(grid.mt_mini)}>{day}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                        {p_.platform !== 'linux' && p_.type === 'reboot_timers' && (
                            <div className={cn(grid.row, grid.mt_md)}>
                                <Radio
                                    onClick={() => onChangeRebootType('reboot', 'on', index)}
                                    selected={timer.rebootType === 'reboot'}
                                    label={translate('reboot_device')}
                                    className={cn(grid.mb_md, grid.mr_md)}
                                />
                                <Radio
                                    onClick={() => onChangeRebootType('restartApp', 'on', index)}
                                    selected={timer.rebootType === 'restartApp'}
                                    label={translate('restart_application')}
                                />
                            </div>
                        )}
                    </div>
                </div>
                {offTimer && (
                    <div className={cn(isSingle ? styles.singleTimer : styles.timer)}>
                        <div className={cn(grid.mb_mini, grid.row)}>
                            <div className={cn(styles.offIcon, grid.mr_mini)}></div>
                            {translate(isDisplayTimer ? 'offDisplayTimer' : 'offTimer')}
                        </div>
                        <div className={cn(styles.timers)}>
                            <div className={cn(grid.mt_md, grid.fullWidth)}>
                                <Dropdown
                                    mod={'default'}
                                    options={repeatOptions}
                                    valueField={'setup'}
                                    label={translate('repeat')}
                                    value={offTimer.setup}
                                    onChange={(selected) => onChangeRepeat(selected, 'off', index)}
                                />
                            </div>
                            {offTimer.setup === 'once' && (
                                <div className={cn(grid.mt_md, grid.fullWidth)}>
                                    <EditText
                                        mod={'withBorder'}
                                        label={translate('date')}
                                        type="date"
                                        value={offTimer.date && moment(offTimer.date).format('DD.MM.YYYY')}
                                        onChange={(value: string) => {
                                            const s_ = { ...state }
                                            const date = moment(value).set({
                                                hour: 0,
                                                minute: 0,
                                                second: 0,
                                                millisecond: 0,
                                            })
                                            const startDate =
                                                timer && timer.date
                                                    ? moment(timer.date).set({
                                                          hour: 0,
                                                          minute: 0,
                                                          second: 0,
                                                          millisecond: 0,
                                                      })
                                                    : null

                                            if (startDate && date < startDate) {
                                                dispatch(emitError('timerCantBeLessStartDate'))

                                                return
                                            }

                                            s_.timers['off'][index].date = moment(value).toISOString(true)

                                            setState(s_)
                                        }}
                                        //minDate={timer.date ? moment(timer.date).toDate() : moment().toDate()}
                                    />
                                </div>
                            )}
                            {offTimer.setup !== 'off' && (
                                <div className={cn(grid.mt_md, grid.fullWidth)}>
                                    <EditText
                                        mod={'withBorder'}
                                        label={translate('time')}
                                        type="text"
                                        mask="99:99:99"
                                        value={offTimer.time}
                                        onChange={(value: string) => {
                                            const s_ = { ...state }
                                            s_.timers['off'][index].time = value

                                            setState(s_)
                                        }}
                                        onBlur={(value: string) => onChangeTime(value, 'off', index)}
                                    />
                                </div>
                            )}
                            {offTimer.setup === 'weekly' && (
                                <div
                                    className={cn(
                                        { [item.hidden]: offTimer.setup !== 'weekly' },
                                        grid.row,
                                        grid.mt_mini,
                                        grid.center,
                                        grid.fullWidth
                                    )}
                                >
                                    {s_.days.map((day, i) => {
                                        const dayIndex = i + 1

                                        return (
                                            <div key={`day__checkbox_${dayIndex}`}>
                                                <Checkbox
                                                    checked={
                                                        offTimer.repeatDays
                                                            ? offTimer.repeatDays.indexOf(dayIndex) !== -1
                                                            : false
                                                    }
                                                    onClick={(selected: any) =>
                                                        onSelectDays(selected, dayIndex, 'off', index)
                                                    }
                                                />
                                                <div className={cn(grid.mt_mini)}>{day}</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {(showVolumeSection || p_.enableSleepMode) && (
                <div className={cn(grid.fullWidth, grid.row, styles.additional)}>
                    {showVolumeSection && (
                        <div className={styles.timer}>
                            {showVolumeOnStart && (
                                <div className={grid.mt_md}>
                                    <Typography className={cn(styles.title)} type="title">
                                        {translate('volumeOnStartDevice')}
                                    </Typography>
                                    <RangeVolume
                                        volume={timer.volume}
                                        onChange={(value: number) => onChangeVolume(value, 'on', index)}
                                    />
                                </div>
                            )}
                            {showAndroidWarning ? (
                                <div className={styles.hint}>*{translate('onTimerAndroidWarning')}</div>
                            ) : null}
                        </div>
                    )}
                    {p_.enableSleepMode && (
                        <div className={styles.timer}>
                            <div className={styles.sleepMode}>
                                <Typography className={cn(styles.title)} type="title">
                                    {translate('sleepMode')}
                                </Typography>
                                <div className={styles.checkbox}>
                                    <Checkbox
                                        labelClassName={styles.label}
                                        onClick={(checked: any) => onChangeSleepMode(checked, 'off', index)}
                                        checked={offTimer.useSleepMode}
                                        label={translate('useSleepMode')}
                                    />
                                </div>
                                <div className={cn(styles.sleepModeDesc, styles.hint)}>
                                    {translate('sleepModeDesc')}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default DeviceSettingsTimer
